module.exports = __webpack_public_path__ + "static/media/Rubik-Regular.5d79135e.woff2";